import { useContext, useEffect, useState } from "react";
import { Redirect, Route } from "react-router";
import { getUserDetail } from "../../../services/httpService/userRequest";
import { GlobalContext } from "../../contexts/globalContext";
import Loader from "../../ui/atoms/Loader/Loader";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const [sharedState, dispatch] = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(true);
  const handleValidateToken = async () => {
    try {
      if (sharedState.user.isLogin === true) {
        setIsLoading(false);
        return;
      }
      const { result } = await getUserDetail(
        `${sharedState.user._id}?fields=email,role,name,profile`
      );
      dispatch("user", {
        name: result.name,
        email: result.email,
        role: result.role,
        profile: result.profile,
        isLogin: true,
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleValidateToken();
  }, []);

  if (isLoading) return <Loader block />;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (sharedState.user.isLogin) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
